{
  "familyId": "MET-LEN-OMREKEN",
  "questions": [
    {
      "id": "MET-LEN-OMREKEN-001",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een kleermaker meet een stuk stof van 3 meter. Hoeveel centimeter is dat?",
      "options": ["300 cm", "30 cm", "3.000 cm", "3 cm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "from": "m",
            "to": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": {
            "type": "length",
            "from": "m",
            "to": "cm",
            "value": 3,
            "highlight": true,
            "showAnimation": true
          }
        }
      ],
      "conceptId": "length_m_to_cm",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De kleermaker rekent om: van meter naar centimeter ga je 2 treden naar beneden op het metriek trapje. Elke trede is ×10. Dus: 3 m = 3 × 100 = 300 cm.",
        "solutionSteps": [
          "Van meter naar centimeter = 2 treden naar beneden",
          "Elke trede is ×10, dus 2 treden = ×100",
          "3 × 100 = 300 cm"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 meter = 300 centimeter (3 × 100 = 300).",
          "1": "Je dacht waarschijnlijk dat je maar 1 trede naar beneden gaat (×10). Maar van meter naar centimeter zijn het 2 treden: 3 × 100 = 300 cm, niet 3 × 10 = 30 cm. Onthoud: m → cm = ×100.",
          "2": "Je dacht waarschijnlijk dat je 3 treden naar beneden gaat (×1.000). Maar van meter naar centimeter zijn het 2 treden (×100), niet 3: 3 × 100 = 300 cm. Onthoud: tel de treden op het trapje.",
          "3": "Je dacht waarschijnlijk dat je deelt in plaats van vermenigvuldigt. Maar van een grote eenheid (meter) naar een kleine eenheid (centimeter) krijg je méér, dus vermenigvuldig je: 3 × 100 = 300 cm. Onthoud: groot → klein = vermenigvuldigen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.length-step-undercount", "label": "Eén trede te weinig (×10 i.p.v. ×100)", "optionIndex": 1 },
          { "id": "met.length-step-overcount", "label": "Eén trede te veel (×1.000 i.p.v. ×100)", "optionIndex": 2 },
          { "id": "met.length-direction-reversed", "label": "Gedeeld i.p.v. vermenigvuldigd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-LEN-OMREKEN-002",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een atleet loopt 5 kilometer. Hoeveel meter is dat?",
      "options": ["50 m", "500 m", "5.000 m", "50.000 m"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "from": "km",
            "to": "m"
          }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": {
            "type": "length",
            "from": "km",
            "to": "m",
            "value": 5,
            "highlight": true,
            "showAnimation": true
          }
        }
      ],
      "conceptId": "length_km_to_m",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De atleet rekent om: van kilometer naar meter ga je 3 treden naar beneden. Elke trede is ×10. Dus: 5 km = 5 × 1.000 = 5.000 m.",
        "solutionSteps": [
          "Van kilometer naar meter = 3 treden naar beneden",
          "Elke trede is ×10, dus 3 treden = ×1.000",
          "5 × 1.000 = 5.000 m"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je maar 1 trede naar beneden gaat (×10). Maar van kilometer naar meter zijn het 3 treden: 5 × 1.000 = 5.000 m, niet 5 × 10 = 50 m. Onthoud: tel de treden op het trapje.",
          "1": "Je dacht waarschijnlijk dat je maar 2 treden naar beneden gaat (×100). Maar van kilometer naar meter zijn het 3 treden: 5 × 1.000 = 5.000 m, niet 5 × 100 = 500 m. Onthoud: km → m = ×1.000.",
          "2": "Goed! 5 kilometer = 5.000 meter (5 × 1.000 = 5.000).",
          "3": "Je dacht waarschijnlijk dat je te veel vermenigvuldigt (×10.000). Maar van kilometer naar meter is ×1.000: 5 × 1.000 = 5.000 m. Onthoud: km → m = precies 3 treden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.length-step-undercount", "label": "Eén trede te weinig (×10 i.p.v. ×1.000)", "optionIndex": 0 },
          { "id": "met.length-step-undercount", "label": "Eén trede te weinig (×100 i.p.v. ×1.000)", "optionIndex": 1 },
          { "id": "met.length-step-overcount", "label": "Eén trede te veel (×10.000)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-LEN-OMREKEN-003",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een timmerman meet een plank van 7 centimeter. Hoeveel millimeter is dat?",
      "options": ["7 mm", "70 mm", "700 mm", "0,7 mm"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "from": "cm",
            "to": "mm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": {
            "type": "length",
            "from": "cm",
            "to": "mm",
            "value": 7,
            "highlight": true,
            "showAnimation": true
          }
        }
      ],
      "conceptId": "length_cm_to_mm",
      "variantIndex": 3,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De timmerman rekent om: van centimeter naar millimeter ga je 1 trede naar beneden: ×10. Dus: 7 cm = 7 × 10 = 70 mm.",
        "solutionSteps": [
          "Van centimeter naar millimeter = 1 trede naar beneden",
          "1 trede = ×10",
          "7 × 10 = 70 mm"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je niet hoeft te vermenigvuldigen. Maar van cm naar mm is 1 trede naar beneden (×10): 7 × 10 = 70 mm. Onthoud: cm → mm = ×10.",
          "1": "Goed! 7 cm × 10 = 70 mm.",
          "2": "Je dacht waarschijnlijk dat je ×100 doet. Maar van cm naar mm is maar 1 trede (×10): 7 × 10 = 70 mm, niet 7 × 100 = 700 mm. Onthoud: tel de treden.",
          "3": "Je dacht waarschijnlijk dat je deelt in plaats van vermenigvuldigt. Maar van groot (cm) naar klein (mm) vermenigvuldig je: 7 × 10 = 70 mm. Onthoud: groot → klein = vermenigvuldigen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.length-direction-reversed", "label": "Niet vermenigvuldigd (groot → klein = ×)", "optionIndex": 0 },
          { "id": "met.length-step-overcount", "label": "Eén trede te veel (×100 i.p.v. ×10)", "optionIndex": 2 },
          { "id": "met.length-direction-reversed", "label": "Gedeeld i.p.v. vermenigvuldigd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-LEN-OMREKEN-004",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een verhuizer meet een kast van 4,5 meter. Hoeveel centimeter is dat?",
      "options": ["4,5 cm", "45 cm", "4.500 cm", "450 cm"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "from": "m",
            "to": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": {
            "type": "length",
            "from": "m",
            "to": "cm",
            "value": 4.5,
            "highlight": true,
            "showAnimation": true
          }
        }
      ],
      "conceptId": "length_m_to_cm_decimal",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De verhuizer rekent om: van meter naar centimeter = ×100. Dus: 4,5 m = 4,5 × 100 = 450 cm. Handig: 4 m = 400 cm, plus 0,5 m = 50 cm → totaal 450 cm.",
        "solutionSteps": [
          "Van meter naar centimeter = 2 treden = ×100",
          "4,5 × 100 = 450 cm",
          "Check: 4 m = 400 cm + 0,5 m = 50 cm → 450 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je niet hoeft te vermenigvuldigen. Maar van groot (m) naar klein (cm) vermenigvuldig je: 4,5 × 100 = 450 cm. Onthoud: groot → klein = vermenigvuldigen.",
          "1": "Je dacht waarschijnlijk dat je maar 1 trede naar beneden gaat (×10). Maar van meter naar centimeter zijn het 2 treden (×100): 4,5 × 100 = 450 cm. Onthoud: m → cm = ×100.",
          "2": "Je dacht waarschijnlijk dat je ×1.000 doet. Maar van meter naar centimeter is ×100, niet ×1.000: 4,5 × 100 = 450 cm. Onthoud: tel de treden op het trapje.",
          "3": "Goed! 4,5 × 100 = 450 cm."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.length-direction-reversed", "label": "Niet vermenigvuldigd met decimaal", "optionIndex": 0 },
          { "id": "met.length-step-undercount", "label": "Eén trede te weinig (×10 i.p.v. ×100)", "optionIndex": 1 },
          { "id": "met.length-step-overcount", "label": "Eén trede te veel (×1.000 i.p.v. ×100)", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-LEN-OMREKEN-005",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een apotheker meet 250 centimeter lint. Hoeveel meter is dat?",
      "options": ["25 m", "2,5 m", "0,25 m", "250 m"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "from": "cm",
            "to": "m"
          }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": {
            "type": "length",
            "from": "cm",
            "to": "m",
            "value": 250,
            "highlight": true,
            "showAnimation": true
          }
        }
      ],
      "conceptId": "length_cm_to_m",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De apotheker rekent om: van centimeter naar meter ga je 2 treden omhoog op het trapje: ÷100. Dus: 250 cm = 250 ÷ 100 = 2,5 m.",
        "solutionSteps": [
          "Van centimeter naar meter = 2 treden omhoog",
          "Omhoog = delen: ÷100",
          "250 ÷ 100 = 2,5 m"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je door 10 deelt. Maar van cm naar m zijn het 2 treden omhoog (÷100): 250 ÷ 100 = 2,5 m, niet 250 ÷ 10 = 25 m. Onthoud: cm → m = ÷100.",
          "1": "Goed! 250 cm ÷ 100 = 2,5 m.",
          "2": "Je dacht waarschijnlijk dat je door 1.000 deelt. Maar van cm naar m zijn het 2 treden (÷100): 250 ÷ 100 = 2,5 m, niet 250 ÷ 1.000 = 0,25 m. Onthoud: tel de treden.",
          "3": "Je dacht waarschijnlijk dat je niet hoeft te delen. Maar van klein (cm) naar groot (m) krijg je mínder, dus deel je: 250 ÷ 100 = 2,5 m. Onthoud: klein → groot = delen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.length-step-undercount", "label": "Eén trede te weinig (÷10 i.p.v. ÷100)", "optionIndex": 0 },
          { "id": "met.length-step-overcount", "label": "Eén trede te veel (÷1.000 i.p.v. ÷100)", "optionIndex": 2 },
          { "id": "met.length-direction-reversed", "label": "Niet gedeeld (klein → groot = ÷)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-LEN-OMREKEN-006",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "fill_in",
      "question": "Reken om: 2 meter = ... centimeter. Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["200"],
        "caseSensitive": false,
        "placeholder": "... cm"
      },
      "stimulusAids": [{ "type": "stairs", "data": { "type": "length", "from": "m", "to": "cm" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "length", "from": "m", "to": "cm", "value": 2, "highlight": true, "showAnimation": true } }],
      "conceptId": "length_m_to_cm_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Van meter naar centimeter ga je 2 treden naar beneden op het metrieke trapje. Elke trede is ×10, dus 2 treden = ×100. Dus 2 m = 2 × 100 = 200 cm. Onthoud: m → cm = altijd ×100.",
        "solutionSteps": ["Van m naar cm = 2 treden = ×100", "2 × 100 = 200 cm"]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "MET-LEN-OMREKEN-007",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "fill_in",
      "question": "Reken om: 3 kilometer = ... meter. Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["3000", "3.000"],
        "caseSensitive": false,
        "placeholder": "... m"
      },
      "stimulusAids": [{ "type": "stairs", "data": { "type": "length", "from": "km", "to": "m" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "length", "from": "km", "to": "m", "value": 3, "highlight": true, "showAnimation": true } }],
      "conceptId": "length_km_to_m_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Van kilometer naar meter ga je 3 treden naar beneden op het metrieke trapje. Elke trede is ×10, dus 3 treden = ×1.000. Dus 3 km = 3 × 1.000 = 3.000 meter. Onthoud: km → m = altijd ×1.000.",
        "solutionSteps": ["Van km naar m = 3 treden = ×1.000", "3 × 1.000 = 3.000 m"]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "MET-LEN-OMREKEN-008",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "fill_in",
      "question": "Een tafel is 150 cm lang. Hoeveel meter is dat? Typ het getal met een komma (bijv. 2,5).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["1,5", "1.5"],
        "caseSensitive": false,
        "placeholder": "... m"
      },
      "stimulusAids": [{ "type": "stairs", "data": { "type": "length", "from": "cm", "to": "m" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "length", "from": "cm", "to": "m", "value": 150, "highlight": true, "showAnimation": true } }],
      "conceptId": "length_cm_to_m_fill_context",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Van centimeter naar meter ga je 2 treden omhoog op het metrieke trapje. Omhoog = delen, dus ÷100. Dus 150 cm = 150 ÷ 100 = 1,5 meter. Handig om te checken: 100 cm = 1 m, plus 50 cm = 0,5 m → totaal 1,5 m ✓.",
        "solutionSteps": ["Van cm naar m = 2 treden omhoog = ÷100", "150 ÷ 100 = 1,5 m", "Check: 100 cm + 50 cm = 1 m + 0,5 m = 1,5 m ✓"]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "MET-LEN-OMREKEN-009",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "ordering",
      "question": "Zet deze lengtes van kort naar lang:",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["5 km", "500 cm", "50 m", "5.000 mm"],
        "correctOrder": [3, 1, 2, 0]
      },
      "stimulusAids": [
        {
          "type": "stairs",
          "data": { "type": "length", "from": "mm", "to": "km" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lengtes vergelijken — reken om naar dezelfde eenheid",
            "content": "Reken alles om naar meter: 5.000 mm = 5 m, 500 cm = 5 m, 50 m = 50 m, 5 km = 5.000 m. Volgorde: 5 m = 5 m < 50 m < 5.000 m. Let op: 5.000 mm en 500 cm zijn allebei 5 meter!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "length_ordering_mixed_units",
      "variantIndex": 9,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Reken alles om naar meter: 5.000 mm = 5 m, 500 cm = 5 m, 50 m = 50 m, 5 km = 5.000 m. Volgorde van kort naar lang: 5.000 mm (5 m) ≤ 500 cm (5 m) < 50 m < 5 km (5.000 m). Let op: 5.000 mm en 500 cm zijn even lang!",
        "solutionSteps": [
          "5.000 mm = 5.000 ÷ 1.000 = 5 m",
          "500 cm = 500 ÷ 100 = 5 m",
          "50 m = 50 m",
          "5 km = 5 × 1.000 = 5.000 m",
          "Volgorde: 5 m, 5 m, 50 m, 5.000 m"
        ]
      }
    },
    {
      "id": "MET-LEN-OMREKEN-010",
      "familyId": "MET-LEN-OMREKEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_omrekenen",
      "questionType": "true_false_series",
      "question": "Zijn deze omrekeningen goed of fout?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "3 m = 300 cm", "isTrue": true },
          { "text": "2 km = 200 m", "isTrue": false },
          { "text": "50 mm = 5 cm", "isTrue": true },
          { "text": "1,5 m = 150 cm", "isTrue": true },
          { "text": "400 cm = 40 m", "isTrue": false }
        ]
      },
      "stimulusAids": [
        {
          "type": "stairs",
          "data": { "type": "length", "from": "mm", "to": "km" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Metriek trapje — lengtematen",
            "content": "km → m = ×1.000. m → cm = ×100. cm → mm = ×10. Omgekeerd: mm → cm = ÷10. cm → m = ÷100. m → km = ÷1.000.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "length_true_false_conversions",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "3 m = 3 × 100 = 300 cm ✓. 2 km = 2 × 1.000 = 2.000 m, niet 200 m ✗ (fout: ×100 i.p.v. ×1.000). 50 mm = 50 ÷ 10 = 5 cm ✓. 1,5 m = 1,5 × 100 = 150 cm ✓. 400 cm = 400 ÷ 100 = 4 m, niet 40 m ✗ (fout: ÷10 i.p.v. ÷100).",
        "solutionSteps": [
          "3 m × 100 = 300 cm ✓ (waar)",
          "2 km × 1.000 = 2.000 m ≠ 200 m ✗ (onwaar)",
          "50 mm ÷ 10 = 5 cm ✓ (waar)",
          "1,5 m × 100 = 150 cm ✓ (waar)",
          "400 cm ÷ 100 = 4 m ≠ 40 m ✗ (onwaar)"
        ]
      }
    }
  ]
}